// The "Working · 1m 5s" clock on a running reporting-chat answer.
//
// The server renders the elapsed seconds; the browser counts on every second between
// polls. Each poll re-renders the clock with a fresh server value, so the start time
// is re-derived: `now - seconds`. That estimate is late by the response's network
// time, which differs per poll, so the earliest estimate seen for a key is kept. The
// clock then never steps backwards and can't drift from the server.
const starts = new Map()

export function startFor(key, seconds, now = Date.now()) {
  const estimate = now - seconds * 1000
  const known = starts.get(key)
  const start = known === undefined ? estimate : Math.min(known, estimate)
  starts.set(key, start)
  return start
}

export function formatElapsed(start, now = Date.now()) {
  const total = Math.max(0, Math.floor((now - start) / 1000))
  return `${Math.floor(total / 60)}m ${total % 60}s`
}

export function forgetStarts() {
  starts.clear()
}
